export default class HelperService {
  // eslint-disable-next-line class-methods-use-this
  getPaginatedLength(totalRows, perPage) {
    return Math.ceil(totalRows / perPage);
  }

  /**
   * Build a query string from a filters object using key value pairs
   * */
  // eslint-disable-next-line class-methods-use-this
  buildSearchQueryString(filters) {
    let query = '?';

    // eslint-disable-next-line no-restricted-syntax
    for (const key in filters) {
      if (filters[key]) {
        query += `${key}=${filters[key]}&`;
      }
    }

    query = query.substr(0, query.length - 1); // remove any extra '&' symbols

    return query;
  }

  /**
   * Get the filters from a page query,
   * requires a filter object containing the valid filters
   * to use (in case extra ones are applied which aren't recognised)
   * @param filters
   * @returns {*}
   */
  // eslint-disable-next-line class-methods-use-this
  getFiltersFromPageQuery(filters, query) {
    const pageParams = query;

    // eslint-disable-next-line no-restricted-syntax
    for (const key in pageParams) {
      // eslint-disable-next-line no-prototype-builtins
      if (pageParams[key] && filters.hasOwnProperty(key)) {
        // eslint-disable-next-line no-param-reassign
        filters[key] = pageParams[key];
      }
    }

    return filters;
  }

  // eslint-disable-next-line class-methods-use-this
  getWeekdays() {
    return ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
  }

  // eslint-disable-next-line class-methods-use-this
  getChartColors() {
    return [
      '#7B2DA4',
      '#0059AF',
      '#003263',
      '#006C72',
      '#00B4BF',
      '#4E1D68',
      '#E99E0D',
      '#D171C2',
      '#B75061',
    ];
  }
}
